import React from "react";

export default function Footer() {
  return (
    <>
      <section className="nakshatra-strip">
        <p className="strip-label">२८ नक्षत्रहरू</p>
        <div className="strip-scroll">
          {[
            "अश्विनी",
            "भरणी",
            "कृत्तिका",
            "रोहिणी",
            "मृगशिरा",
            "आर्द्रा",
            "पुनर्वसु",
            "तिष्य",
            "आश्लेषा",
            "मघा",
            "पूर्वाफाल्गुनी",
            "उत्तराफाल्गुनी",
            "हस्त",
            "चित्रा",
            "स्वाती",
            "विशाखा",
            "अनुराधा",
            "ज्येष्ठा",
            "मूल",
            "पूर्वाषाढा",
            "उत्तराषाढा",
            "अभिजित",
            "श्रवण",
            "धनिष्ठा",
            "शतभिषा",
            "पूर्वभाद्रपद",
            "उत्तरभाद्रपद",
            "रेवती",
          ].map((n) => (
            <span key={n} className="strip-item">
              ✦ {n}
            </span>
          ))}
        </div>
      </section>

      <footer className="footer">
        <div className="footer-top">
          <div className="footer-brand">
            <span className="logo-symbol">✦</span>
            <span className="logo-text">
              <span className="logo-nep">नक्षत्र</span>
              <span className="logo-eng">NAKSHATRA NEPAL</span>
            </span>
          </div>
          <p className="footer-tagline">
            वैदिक ज्योतिषको विश्वसनीय डिजिटल स्रोत
          </p>
        </div>
        <div className="footer-divider" />
        <div className="footer-bottom">
          <div className="footer-info">
            <p className="footer-owner">Ganesh Acharya</p>
            <a href="mailto:emmet.itc@gmail.com" className="footer-email">
              emmet.itc@gmail.com
            </a>
          </div>
          <p className="footer-copy">
            © 2026 Nakshatra Nepal. All rights reserved.
          </p>
        </div>
      </footer>
    </>
  );
}
